import React from 'react';
export const MessageSquare2 = _ref => {
  let {
    color = 'currentColor',
    size = '24'
  } = _ref;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color,
    stroke: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M21.39,15.17H12L5,22.83V15.17H2.6A1.6,1.6,0,0,1,1,13.57V2.79A1.63,1.63,0,0,1,2.62,1.17H21.38A1.63,1.63,0,0,1,23,2.8V13.56A1.61,1.61,0,0,1,21.39,15.17Z"
  }));
};